import { render } from "./forminput.vue?vue&type=template&id=66bd4e98"
import script from "./forminput.vue?vue&type=script&lang=js"
export * from "./forminput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\erenk\\source\\repos\\erenkorkmaz53\\eTalep\\eCampus\\eCampus.WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__